function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import jwt from 'jsonwebtoken';
import Constant from './constant';
import Config from './config';
import dayjs from 'dayjs';
import jsrsasign from 'jsrsasign';
import { request } from '../utils';
import { getEnvKey } from '../utils/getEnvKey';
var Base64 = require('js-base64').Base64;
export function getParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}
var replaceLoginState = function replaceLoginState() {
  var href0 = window.location.href.split('?')[0];
  var href1 = window.location.href.split('?')[1];
  var params = '';
  if (href1) {
    var paths = href1.split('&');
    var pathUrl = paths.filter(function (item) {
      return !item.includes('access_token') && !item.includes('ACCESS_TOKEN');
    });
    params = pathUrl.join('&');
  }
  var result = '';
  if (params != '') {
    result = "".concat(href0, "?").concat(params);
  } else {
    result = "".concat(href0);
  }
  // window.location.href = result;
  window.history.replaceState({}, '', result);
};
/**
 * 解析token
 * @param accessToken
 * @returns
 */
var getUserInfoToAccessToken = function getUserInfoToAccessToken(accessToken) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resovle, reject) {
      var aToken, ct;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            aToken = jwt.decode(accessToken);
            sessionStorage.setItem('USER_INFO', JSON.stringify(aToken.user_info));
            _context.next = 4;
            return getParam('ct');
          case 4:
            ct = _context.sent;
            if (ct) {
              sessionStorage.setItem('ct', ct);
            }
            return _context.abrupt("return", resovle(aToken.user_info));
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
/**
 * 页面跳转
 * @param accessToken
 * @returns
 */
export var toHref = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(accessToken) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resovle, reject) {
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    getUserInfoToAccessToken(accessToken).then(function (res) {
                      replaceLoginState();
                      return resovle(res);
                    });
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x4, _x5) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function toHref(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * 是否登陆
 */
export function isLogin() {
  if (sessionStorage.getItem(Constant.access_token)) {
    return true;
  }
  return false;
}
// 公钥
export function getPUBK(_x6, _x7, _x8, _x9) {
  return _getPUBK.apply(this, arguments);
}
function _getPUBK() {
  _getPUBK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(mode, authLoginType, client_secret, client_id) {
    var pubk, basicSecret, timestamp;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getEnvKey('PUBK', mode, authLoginType);
        case 2:
          pubk = _context4.sent;
          basicSecret = 'Basic ' + Base64.encode("".concat(client_id || Config.appId, ":").concat(client_secret || Config.appSecret));
          timestamp = new Date().getTime();
          basicSecret = jsrsasign.hextob64u(
          // @ts-ignore
          jsrsasign.KJUR.crypto.Cipher.encrypt(basicSecret + '\n' + timestamp, jsrsasign.KEYUTIL.getKey(pubk)));
          return _context4.abrupt("return", basicSecret);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getPUBK.apply(this, arguments);
}
export function saveToken(_x10) {
  return _saveToken.apply(this, arguments);
}
function _saveToken() {
  _saveToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(data) {
    var expires_in;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          console.log(data);
          sessionStorage.setItem(Constant.access_token, data.access_token);
          sessionStorage.setItem(Constant.refresh_token, data.refresh_token);
          sessionStorage.setItem(Constant.expires_in, data.expires_in);
          expires_in = dayjs().add(data.expires_in, 's').unix();
          sessionStorage.setItem(Constant.token_expires_time, expires_in + '');
          sessionStorage.setItem(Constant.user_info, JSON.stringify(data.user_info));
          sessionStorage.setItem(Constant.user_name, data.user_info.name);
          localStorage.setItem('storeSessionData', JSON.stringify({
            userInfo: data.user_info,
            token: data.access_token
          }));
          sessionStorage.setItem('pt', data.pt || '');
          if (sessionStorage.getItem(Constant.user_info) && sessionStorage.getItem(Constant.access_token)) {
            // window.location.href = Config.urlHref || Config.baseUrl;
          }
          return _context5.abrupt("return");
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _saveToken.apply(this, arguments);
}
export function accestokenByCode(_x11, _x12, _x13) {
  return _accestokenByCode.apply(this, arguments);
}
/**
 * 删除Token
 */
function _accestokenByCode() {
  _accestokenByCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(config, code, basicSecret) {
    var _data$data;
    var data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request(config.path + '/oauth/token', {
            data: {
              ct: sessionStorage.getItem('ct') || '1',
              grant_type: 'authorization_code',
              code: code,
              redirect_uri: config.urlHref || Config.baseUrl,
              fp: localStorage.getItem('fp'),
              v: 1
            },
            headers: {
              // Authorization: 'Basic ' + BasicSecret,
              Authorization: basicSecret
            },
            requestType: 'form',
            method: 'post'
          });
        case 2:
          data = _context6.sent;
          saveToken(data.data);
          return _context6.abrupt("return", (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.user_info);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _accestokenByCode.apply(this, arguments);
}
export function delToken(_x14) {
  return _delToken.apply(this, arguments);
}
// msg 0 或者不传是发消息登出，其他值不发消息，-99 修改密码所有端登出
function _delToken() {
  _delToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          sessionStorage.removeItem(Constant.access_token);
          sessionStorage.removeItem(Constant.refresh_token);
          sessionStorage.removeItem(Constant.expires_in);
          sessionStorage.removeItem(Constant.token_expires_time);
          sessionStorage.removeItem(Constant.user_info);
          sessionStorage.removeItem(Constant.user_name);
          sessionStorage.removeItem('selectedKeys');
          // sessionStorage.removeItem('noclose');
          sessionStorage.removeItem('openKeys');
          localStorage.removeItem('dict_code');
          // sessionStorage.clear();
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _delToken.apply(this, arguments);
}
export function deleteToken(_x15, _x16, _x17, _x18, _x19) {
  return _deleteToken.apply(this, arguments);
}
function _deleteToken() {
  _deleteToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(authUrl, e, s, msg, uId) {
    var userInfo, storePtValue, userId, fp, aUrl, userInfoId, _userInfoId, amsg;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          userInfo = getUserInfo();
          storePtValue = sessionStorage.getItem('pt') || 1;
          userId = uId ? uId : userInfo && userInfo.id ? userInfo.id : '';
          fp = localStorage.getItem('fp');
          delToken(e);
          aUrl = authUrl && authUrl != '' ? authUrl : Config.baseUrl + '/auth';
          if (e && e === 1) {
            userInfoId = userId && userId != '' ? userId : s ? s : '';
            if (userInfoId && userInfoId != '') {
              window.location.href = aUrl + "/logout?ct=1&userId=".concat(userInfoId, "&fp=").concat(fp, "&pt=").concat(storePtValue);
            }
          } else {
            _userInfoId = userId && userId != '' ? userId : s ? s : '';
            amsg = msg || 0;
            if (_userInfoId && _userInfoId != '') {
              // if (navigator.userAgent.indexOf('QQBrowser') != -1) {
              //   request(
              //     aUrl +
              //       `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`,
              //     {
              //       method: 'get',
              //     }
              //   ).then(() => {
              //     closeWindow()
              //   })
              // } else
              if (navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) {
                window.location.href = aUrl + "/logout?ct=1&userId=".concat(_userInfoId, "&fp=").concat(fp, "&pt=").concat(storePtValue, "&msg=").concat(amsg);
                // setTimeout(() => {
                //   closeWindow();
                // }, 500);
              } else {
                fetch(aUrl + "/logout?ct=1&userId=".concat(_userInfoId, "&fp=").concat(fp, "&pt=").concat(storePtValue, "&msg=").concat(amsg), {
                  method: 'get'
                });
                // .then(() => {
                //   closeWindow();
                // });
              }
              // window.location.href =
              //     aUrl +
              //     `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`;
            }
          }
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _deleteToken.apply(this, arguments);
}
export var getUserInfo = function getUserInfo() {
  return JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
};
/**
 * 关闭浏览器窗口
 */
export var closeWindow = function closeWindow(type) {
  console.log(type);
  if (window.sessionStorage.getItem('noclose')) {
    window.sessionStorage.removeItem('noclose');
    return;
  }
  if (window.location.pathname.includes('portal') && type == 3) {
    return;
  }
  // if (navigator.userAgent.indexOf("MSIE") > 0) {
  //   if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
  //     window.opener = null;
  //     window.close();
  //   } else {
  //     window.open('', '_top');
  //     window?.top?.close();
  //   }
  // } else if (navigator.userAgent.indexOf("Firefox") > 0) {
  //   window.location.href = 'about:blank ';
  // } else {
  //   window.opener = null;
  //   window.open('', '_self', '');
  //   window.close();
  // }
  if (navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) {
    var _open;
    (_open = open(location, '_self')) === null || _open === void 0 ? void 0 : _open.close();
    window.location.href = 'about:blank';
    window.close();
  } else {
    var _open2;
    window.opener = null;
    window.open('', '_self');
    window.close();
    (_open2 = open(location, '_self')) === null || _open2 === void 0 ? void 0 : _open2.close();
  }
  window.close();
};